import {
  Checkbox,
  FormControlLabel,
  ListItemIcon,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Menu } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function ResultsTableTableCell(props) {
  const classes = useStyles(props);

  function changeLabel(index, val) {
    var temp = [...props.tableData];
    temp[index].display = val;
    props.setTableData(temp);
  }

  function changeSelected(index) {
    var temp = [...props.tableData];
    temp[index].selected = !temp[index].selected;
    props.setTableData(temp);
  }

  function changeSorted(index) {
    var temp = [...props.tableData];
    temp[index].isSortable = !temp[index].isSortable;
    props.setTableData(temp);
  }

  return (
    <>
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Selected" ? (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={props.element.selected}
                    onChange={() => changeSelected(props.index)}
                  />
                }
                label=""
              />
            ) : column.label === "Display Name" ? (
              <TextField
                placeholder="Label"
                label="Label"
                variant="standard"
                fullWidth
                style={{ minWidth: "100px" }}
                value={props.element.display}
                onChange={(e) => changeLabel(props.index, e.target.value)}
              />
            ) : column.label === "Sortable" ? (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={props.element.isSortable}
                    onChange={() => changeSorted(props.index)}
                  />
                }
                label=""
              />
            ) : column.label === "" ? (
              <ListItemIcon size="large" className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
